import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { environment } from 'src/environments/environment';

@Injectable({
  providedIn: 'root'
})
export class LogisticsTenantOrgService {

  baseUrl: string = `${environment.logisticsApiUrl}/TenantOrg`;

  constructor(private http: HttpClient) {

  }

  /**
   * Get Org Options for DropDown
   */
  getTenantOrgOptions(): Observable<any> {
    const url = this.baseUrl + `/getTenantOrgOptions`;
    return this.http.get(url);
  }

}
